module.exports = __webpack_public_path__ + "img/image-22.91756977.jpg";